<!-- Skeleton Loader Mode -->
<div *ngIf="mode === 'skeleton'" class="product-card-vanguard skeleton-card">
  <div class="card-inner">
    <div class="card-image-wrapper skeleton-shimmer"></div>
    <div class="card-info">
      <div class="skeleton-line brand skeleton-shimmer"></div>
      <div class="skeleton-line desc skeleton-shimmer"></div>
      <div class="skeleton-line price skeleton-shimmer"></div>
    </div>
    <div class="card-actions">
      <div class="skeleton-button skeleton-shimmer"></div>
    </div>
  </div>
</div>

<!-- usado en resutlados de busqueda y en la seccion Destacados del home -->
<div *ngIf="mode === 'normal' || mode === 'destacado'" class="product-card-vanguard"
  [class.card-destacado]="mode === 'destacado'">
  <div class="card-inner">
    <!-- Badges Row -->
    <div class="card-badges">
      <div class="badge online" *ngIf="articulo.isdeOferta()">EXCLUSIVO ONLINE</div>
      <div class="badge promo" *ngIf="articulo.misPromo && articulo.misPromo.length > 0">
        {{articulo.getPromos()[0].getAbreviaturaPromocion() || articulo.getPromos()[0].getNombrePromocion()}}
      </div>
    </div>

    <!-- Image Section -->
    <div class="card-image-wrapper" (click)="openArtModal(); artOpened(articulo)">
      <img *ngIf="articulo.getImgDownload()" class="product-image" [src]="articulo.getFotoImagen()" loading="lazy"
        [alt]="articulo.getNombreMarca()">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
        [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
        [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
      <div class="image-overlay">
        <button class="btn-ver-producto">Ver Producto</button>
      </div>
    </div>
    <!-- Sub-image Badge (e.g. Instantaneo 100g style) 
    <div class="sub-image-info" *ngIf="articulo.getUnidadMedida()">
      <span class="type">{{articulo.getNombreRubro()}}</span>
      <span class="weight">{{articulo.getFraccion()?articulo.getFraccion():''}} {{articulo.getUnidadMedida()}}</span>
    </div> -->

    <!-- Info Section -->
    <div class="card-info" (click)="openArtModal(); artOpened(articulo)">
      <div class="brand-name">{{ articulo.getNombreMarca() }}</div>
      <div class="product-desc">{{articulo.getDescripCion()}} {{articulo.getPresentacion()}}</div>
      <div class="product-desc" *ngIf="permiteBultosArticulo()">
          Venta x bulto ({{articulo.getUnidadesPorBulto()}} uxb)
      </div>

      <div class="pricing-container" *ngIf="!ocultarPrecios">
        <!-- Wholesale / Promo Condition -->
        <div class="promo-condition" *ngIf="articulo.getCantidadMayorista() > 0">
          Llevando {{articulo.getCantidadMayorista()}} o más
        </div>

        <div class="price-row">
          <div class="main-price">
            {{ (articulo.isdeOferta() ? articulo.getPrecioOferta() : articulo.getPrecio()) | currency }}
            <span class="unit">c/u</span>
          </div>
          <div class="badge-discount" *ngIf="articulo.misPromo && articulo.misPromo.length > 0">
            {{articulo.getPromos()[0].getAbreviaturaPromocion()}}
          </div>
        </div>

        <!-- Strikethrough Price -->
        <div class="old-price" *ngIf="articulo.isdeOferta()">
          {{ articulo.getPrecio() | currency }}
        </div>

        <!-- Detailed Pricing -->
        <div class="extra-pricing">
          <div class="price-per-unit" *ngIf="articulo.getPrecioPartido() !== -1">
            Precio regular {{articulo.getOtrosPrecios()}}: {{articulo.getPrecioPartido() | currency}}
          </div>
          <div class="price-no-tax">
            PRECIO S/IMP NAC: {{articulo.getPrecioSinImp() | currency}}
          </div>
        </div>
      </div>
    </div>

    <!-- Action Section -->
    <div class="card-actions">
      <ng-container *ngIf="!permiteBultosArticulo(); else sumadorBultosCard">
        <boton-sumador class="vanguard-sumador" [fraccion]="articulo.getFraccion()" [unidadMedida]="articulo.getUnidadMedida()"
          (quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()" [modo]="'vanguard'">
        </boton-sumador>
      </ng-container>
      <ng-template #sumadorBultosCard>
        <boton-sumador class="vanguard-sumador" [fraccion]="1" [unidadMedida]="''"
          (quantyEvent)="sumaeventBultos($event)" [contador]="articulo.getCantidadBultos()" [modo]="'vanguard'">
        </boton-sumador>
      </ng-template>
    </div>
  </div>
</div>
<!-- usado en pantalla de seleccion de envio/retiro y eleccion de medio de pago-->
<div *ngIf="mode==='postcheckout'" class="boxcheckout" (click)="artOpened(articulo)">
  <div class="image-container-watermark">
    <img *ngIf="articulo.getImgDownload()" class="checkoutimagen" [heigth]="150" [width]="150"
      [src]="articulo.getFotoImagen()" loading="lazy">
    <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
        [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
        [style.opacity]="genServ.getOpacidadMarcadeagua()">
    </div>
  </div>
  <div class="detallescheckout">

    <div class="descripcheckout">
      {{articulo.getDescripCion()}}
    </div>

    <div class="marcachekout">
      {{articulo.getPresentacion()}}
    </div>

    <div class="unidadescheckout">
      <div class="cantidades-checkout">
        <div *ngIf="!articulo.getFraccion()">
          {{ articulo.getCantidad() }} {{ articulo.getCantidad() === 1 ? 'unidad': 'unidades'}}
        </div>
        <div *ngIf="permiteBultosArticulo() || articulo.getCantidadBultos() > 0">
          {{ articulo.getCantidadBultos() }} {{ articulo.getCantidadBultos() === 1 ? 'bulto': 'bultos'}}
        </div>
        <div *ngIf="articulo.getFraccion()">
          {{articulo.getCantidad()}} {{ articulo.getUnidadMedida() }}
        </div>
      </div>
    </div>
  </div>

</div>
<!-- usado en carrito modal -->
<div *ngIf="mode === 'slim'" class="slimorden border">
  <div class="myboxslim">
    <div class="image-col image-container-watermark">
      <img *ngIf="articulo.getImgDownload()" [height]="38" [width]="38" class="minimages myimg"
        [src]="articulo.getFotoImagen()" loading="lazy" [alt]="articulo.getNombreMarca()">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
           [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
           [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>

    <div class="info-col">
      <div class="minititle">
        {{articulo.getDescripCion()}}
      </div>
      <div class="descmini">
        {{articulo.getPresentacion()}}
      </div>
      <div *ngIf="!ocultarPrecios" class="miyoferta">
        <div class="slimorden">
          <div *ngFor="let oferta of articulo.getPromosActivas()" class="oferta">
            {{oferta}}
          </div>
        </div>
      </div>
    </div>
    <div class="sumador-col">
      <div class="botonsun">
        <ng-container *ngIf="permiteBultosArticulo(); else sumadorUnidadesSlim">
          <ng-container *ngIf="tieneBultosCargados(); else sinUnidadesPorBultoSlim">
            <div class="bultos-no-aplica-slim">
              {{ getUnidadesEquivalentesBultos() }}
            </div>
          </ng-container>

          <ng-template #sinUnidadesPorBultoSlim>
            <div class="bultos-no-aplica-slim">—</div>
          </ng-template>

          <div class="label-unidades">Unidades</div>
        </ng-container>

        <ng-template #sumadorUnidadesSlim>
          <boton-sumador
            class="botonSumadorSlim"
            [fraccion]="articulo.getFraccion()"
            [unidadMedida]="articulo.getUnidadMedida()"
            (quantyEvent)="sumaevent($event)"
            [modo]="'detail'"
            [contador]="articulo.getCantidad()">
          </boton-sumador>
          <div class="label-unidades">Unidades</div>
        </ng-template>
      </div>

      <div class="botonsun" *ngIf="muestraBultosGlobal()">
        <ng-container *ngIf="permiteBultosArticulo(); else sinBultosArticuloSlim">
          <boton-sumador
            class="botonSumadorSlim"
            (quantyEvent)="sumaeventBultos($event)"
            [modo]="'detail'"
            [contador]="articulo.getCantidadBultos()">
          </boton-sumador>
          <div class="label-unidades">Bultos</div>
        </ng-container>

        <ng-template #sinBultosArticuloSlim>
          <div class="bultos-no-aplica-slim">—</div>
          <div class="label-unidades label-vacia">&nbsp;</div>
        </ng-template>
      </div>
    </div>
    <div class="actions-col">
      <div (click)="eliminar()" class="eliminarbtn">
        Quitar <span class="naiz">X</span>
      </div>
      <div *ngIf='!ocultarPrecios' class="prices-wrapper">
        <!-- Line 1: Unit prices (Original crossed out + Offer/Regular) -->
        <div class="price-line original" *ngIf="articulo.isdeOferta()">
          <span *ngIf="!articulo.getFraccion()">{{ articulo.getPrecio() | currency}}</span>
          <span *ngIf="articulo.getFraccion()">{{ articulo.getPrecio() * articulo.getFraccion() | currency}}</span>
        </div>

        <div class="price-line current">
          <span class="precio-unit" [class.oferta-text]="articulo.isdeOferta()">
            <span *ngIf="articulo.isdeOferta()">
              {{articulo.getPrecioOferta() | currency}} u.
            </span>
            <span *ngIf="!articulo.isdeOferta()">
              <span *ngIf="!articulo.getFraccion()">{{articulo.getPrecio() | currency}}</span>
              <span *ngIf="articulo.getFraccion()">{{ articulo.getPrecio() * articulo.getFraccion() | currency }}</span>
              u.
            </span>
          </span>
        </div>

        <!-- Line 2: Total price -->
        <div class="price-line total">
          <div class="preciomini" *ngIf="articulo.getPromosActivas().length==0 ; else conpromo">
            <div *ngIf="!articulo.getFraccion()">
              {{ getPrecioCalculadoCarrito() | currency }}
            </div>
            <div *ngIf="articulo.getFraccion()">
              {{ articulo.getPrecioCalculado() * articulo.getFraccion() | currency }}
            </div>
          </div>
          <ng-template #conpromo>
            <div class="preciomini">
              <!-- Subtotal tachado ONLY if NO offer (user said: si tiene oferta no pongas el subtotal original) -->
              <!-- Tampoco si es combo: el precio de línea del combo se calcula igual que el tachado, así que no representa un descuento real -->
              <span class="tachado" *ngIf="!articulo.isdeOferta() && !esPromoCombo()">
                <span class="tachado-price">
                  {{ (articulo.getPrecio() * getCantidadParaMonto()) | currency }}
                </span>
              </span>
              <div class="preciron" *ngIf="esPromoCombo()">
                {{ getPrecioCalculadoCarrito() | currency }}
              </div>
              <div class="preciron"
                *ngIf="!esPromoCombo() && articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() != 0">
                {{ getPrecioCalculadoCarrito() | currency }}
              </div>
              <div class="preciron"
                *ngIf="!esPromoCombo() && articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() === 0">
                {{ precioLineaConPromo() | currency }}
              </div>
              <div class="preciron" *ngIf="articulo.isdePromo === false && articulo.isdeOferta() === true">
                {{ articulo.getPrecioOferta() * getCantidadParaMonto() | currency}}
              </div>
              <div class="preciron" *ngIf="articulo.isdePromo === false && articulo.isdeOferta() === false">
                {{ getPrecioCalculadoCarrito() | currency }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- resultados temporales en barra de busqueda -->
<div *ngIf="mode==='ultraslim'" class="minibox">
  <div class="descuentodel">
    0% de Descuento
  </div>
  <div class="nombredelprod">
    <span class="resaltado"> {{articulo.getNombreMarca()}}</span> {{articulo.getDescripCion()}}.
    {{articulo.getPresentacion()}}
  </div>
  <div class="preciodeofert">
    {{articulo.getPrecio() | currency}}
  </div>
  <div class="image-container-watermark">
    <img *ngIf="articulo.getImgDownload()" class="carruimages" [heigth]="150" [width]="150"
      [src]="articulo.getFotoImagen()" loading="lazy" [alt]="articulo.getNombreMarca()">
    <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
         [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
         [style.opacity]="genServ.getOpacidadMarcadeagua()">
    </div>
  </div>


</div>
<!-- usado en pantalla de detalles de pedido -->
<div *ngIf="mode==='detalletrakin'" class="mytabla2">

  <div class="prod2">
    <div class="image-container-watermark">
      <img class="myimg2" [src]="articulo.getFotoImagen()" loading="lazy">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
           [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
           [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>
    <div class="labelgrande2">
      <span class="descrmarca2">{{articulo.getDescripCion()}}. {{articulo.getPresentacion()}}</span>
    </div>

  </div>
  <div class="containerPrecio">
    <ng-container *ngIf='!ocultarPrecios'>
      <div class="preciu center" *ngIf='articulo.isdeOferta()'>
        <span class="tachado" *ngIf='articulo.isdeOferta()'>{{articulo.getPrecio() | currency}}</span>
        {{articulo.getPrecioOferta() | currency}}
      </div>
      <div class="preciu center" *ngIf='!articulo.isdeOferta()'>
        {{(articulo.getPrecio()) | currency}}
      </div>
      <div *ngIf="!articulo.getFraccion()" class="canti2 center">
        x {{articulo.getCantidad()}} unidades
      </div>
      <div *ngIf="articulo.getFraccion()" class="canti2 center">
        x {{ articulo.getCantidad()}} {{ articulo.getUnidadMedida()}}
      </div>
      <div class="preciureal center"
        *ngIf="articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() != 0">
        {{articulo.getPrecioCalculado() | currency}}
      </div>
      <div class="preciureal center"
        *ngIf="articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() === 0">
        <span class="tachado">{{ getPrecioCalculadoCarrito() | currency }}</span>
        {{ precioLineaConPromo() | currency}}
      </div>
      <div class="preciureal center" *ngIf="articulo.isdePromo === false">
        {{ getPrecioCalculadoCarrito() | currency }}
      </div>
    </ng-container>
  </div>
  <!-- <div class="preciureal2 center">
        {{ getPrecioCalculadoCarrito() | currency }} (precio total)
    </div> -->
  <div class="options2 center">

  </div>

</div>
<!-- usado en carrito -->
<div *ngIf="mode==='detalle'" class="mytabla" [class.sin-bultos]="!muestraBultosGlobal()">
  <div class="acciones-item">
    <div class="elimin noselect" (click)="eliminar()">
      <i class="mdi mdi-delete eliminarArt"></i>
      <div class="icolabel">Eliminar</div>
    </div>
    <div class="observacion noselect" (click)="abrirModalObservacion()">
      <i class="mdi mdi-note-edit observacionArt"></i>
      <div class="icolabel">Observación</div>
    </div>
  </div>
  <div class="image-container-watermark">
    <img class="myimg imgajuster" [src]="articulo.getFotoImagen()" [heigth]="100" [width]="100" loading="lazy">
    <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
      [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
      [style.opacity]="genServ.getOpacidadMarcadeagua()">
    </div>
  </div>
  <div class="labelgrande">
    <span class="descrmarca">{{articulo.getDescripCion()}}. {{articulo.getPresentacion()}}</span>
  </div>
  <div *ngIf='!ocultarPrecios'>
    <div class="preciu center" *ngIf='articulo.isdeOferta()'>
      <div *ngIf="width < 600">
        Precio x Un:
      </div>
      <span class="tachado" *ngIf='articulo.isdeOferta()'>
        <div *ngIf="!articulo.getFraccion()">
          {{articulo.getPrecio() | currency}}
        </div>
        <div *ngIf="articulo.getFraccion()">
          {{ articulo.getPrecio() * articulo.getFraccion() | currency }}
        </div>
      </span>
      <div *ngIf="!articulo.getFraccion()">
        {{articulo.getPrecioOferta() | currency}}
      </div>
      <div *ngIf="articulo.getFraccion()">
        {{ articulo.getPrecioOferta() * articulo.getFraccion() | currency }}
      </div>
    </div>
    <div class="preciu center" *ngIf='articulo.isdeOferta() === false'>
      <div *ngIf="width < 600">
        Precio x Un:
      </div>
      <div>
        {{articulo.getPrecio() | currency}}
      </div>
    </div>
  </div>
  <div class="canti center">
    <ng-container *ngIf="tieneBultosCargados(); else sumadorCantidadDetalle">
      <span class="cantidad-equivalente-detalle">{{ getUnidadesEquivalentesBultos() }}</span>
    </ng-container>

    <ng-template #sumadorCantidadDetalle>
      <boton-sumador [fraccion]="articulo.getFraccion()" [unidadMedida]="articulo.getUnidadMedida()"
        (quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()" [modo]="'detail'">
      </boton-sumador>
    </ng-template>
  </div>
  <div class="bultos center" *ngIf="muestraBultosGlobal()">
    <ng-container *ngIf="permiteBultosArticulo(); else sinBultosArticulo">
      <boton-sumador (quantyEvent)="sumaeventBultos($event)" [contador]="articulo.getCantidadBultos()"
      [modo]="'detail'">
      </boton-sumador>
    </ng-container>
    <ng-template #sinBultosArticulo>
      <span class="bultos-no-aplica">—</span>
    </ng-template>
  </div>
  <div *ngIf='!ocultarPrecios'>
    <div class="preciureal center"
      *ngIf="articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() !== 0">
      <div *ngIf="width < 600">
        Total:
      </div>
      <div>
        {{ getPrecioCalculadoCarrito() | currency }}
      </div>
    </div>
    <div class="preciureal center"
      *ngIf="articulo.isdePromo === true && articulo.misPromo && articulo.misPromo[0] && articulo.getCantidad() % articulo.misPromo[0].cantidadenPromo() === 0">

      <div *ngIf="width < 600">
        Total:
      </div>
      <span *ngIf="articulo.isdeOferta()" class="tachado">
        <div>
          {{ getPrecioCalculadoCarrito() | currency }}
        </div>
      </span>
      <span *ngIf="!articulo.isdeOferta()" class="tachado">
        <div>
          {{(articulo.getPrecio() * articulo.getCantidad())| currency}}
        </div>
      </span>
      <div>
        {{ precioLineaConPromo() | currency}}
      </div>
    </div>
    <div class="preciureal center" *ngIf="articulo.isdePromo === false">
      <div *ngIf="width < 600">
        Total:
      </div>
      <div>
        {{ getPrecioCalculadoCarrito() | currency }}
      </div>
    </div>
  </div>
  <!--
  <div class="options center">
    <mmax-input-selector [opciones]="articulo.getRemplazos()" (onSelect)="categoriaSelec($event)">
    </mmax-input-selector>
  </div> -->

</div>
<!-- los resultados adentro de barra de busqueda -->
<div *ngIf="mode==='buqueda'" class="prediccion" (click)="iraSeach();" onclick="window.scrollTo(0,0)">
  <i class="mdi mdi-magnify icono" style="font-size: 16px; color: var(--text-muted);"></i>
  <div class="descrip">
    {{articulo.getDescripCion()}}.
  </div>
</div>
<!-- usado en pantalla de Ofertas y Promociones -->
<div *ngIf="mode === 'ofertas'" class="anotherbox">
  <div (click)="openArtModal(); artOpened(articulo)">
    <div class="ofertareal" *ngIf='articulo.isdeOferta() && !ocultarPrecios'>
      <div class="labeloferta">
        Oferta!
      </div>
    </div>
    <div class="imag image-container-watermark">
      <img *ngIf="articulo.getImgDownload()" class="imasrc" id="imagsrc" [heigth]="150" [width]="150"
        [src]="articulo.getFotoImagen()" loading="lazy" [alt]="articulo.getNombreMarca()">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
        [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
        [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>
    <div class="anotherandanother">
      <div class="mindesc">
        {{articulo.getDescripCion()}}
      </div>
      <div class="tittle">
        {{articulo.getPresentacion()}}
      </div>
      <!-- <div class="preciochico">
                    {{articulo.getPrecioPartido() | currency}} {{articulo.getOtrosPrecios()}}
                </div> -->
      <span class="tachado">{{articulo.getPrecio() | currency}}</span>
      <div class="precio">
        <div class="preciogrande">
          {{( articulo.getPrecioOferta() * 1)| currency}}
        </div>
        <div class="porcantidad">
          x un
        </div>
      </div>
    </div>
  </div>
  <boton-sumador class="sumador" [fraccion]="articulo.getFraccion()" [unidadMedida]="articulo.getUnidadMedida()"
    (quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()"></boton-sumador>
</div>
<!-- usado en landing page en seccion ofertas  -->
<div *ngIf="mode === 'ofertas-land'" class="anotherboxOfertaLand">
  <div (click)="openArtModal(); artOpened(articulo)">
    <div style="display: flex;">
      <div class="ofertareal" *ngIf='articulo.isdeOferta() && !ocultarPrecios'>
        <div class="labeloferta">
          Oferta!
        </div>
      </div>
      <div class="imag image-container-watermark">
        <img *ngIf="articulo.getImgDownload()" class="imasrc" id="imagsrc" [heigth]="150" [width]="150"
          [src]="articulo.getFotoImagen()" loading="lazy" [alt]="articulo.getNombreMarca()">
        <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
          [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
          [style.opacity]="genServ.getOpacidadMarcadeagua()">
        </div>
      </div>
    </div>
    <div class="anotherandanother">
      <div class="mindesc">
        {{articulo.getDescripCion()}}
      </div>
      <div class="tittle">
        {{articulo.getPresentacion()}}
      </div>
      <div class="pricing-stack" *ngIf='!ocultarPrecios'>
        <span class="tachado">{{articulo.getPrecio() | currency}}</span>
        <div class="price-row">
          <div class="preciogrande">
            {{( articulo.getPrecioOferta() * 1)| currency}}
          </div>
          <div class="porcantidad">
            x un
          </div>
        </div>
      </div>
    </div>
  </div>
  <boton-sumador class="botonSumadorOfertaLand" [fraccion]="articulo.getFraccion()"
    [unidadMedida]="articulo.getUnidadMedida()" (quantyEvent)="sumaevent($event)"
    [contador]="articulo.getCantidad()"></boton-sumador>

</div>
<div *ngIf="mode === 'promos' && articulo.getPrecioAmostrar() != 0" class="ofertacard">
  <div class="contenidoofert">
    <div class="oferlogo">
      {{articulo.getTipoPromo()}}
    </div>
    <div class="ofertext">
      {{articulo.getDescripCion()}}
    </div>
    <div class="imagepr image-container-watermark">
      <img class="img-pr" *ngIf="articulo.getImgDownload()" [src]="articulo.getFotoImagen()" [heigth]="150"
        [width]="150" loading="lazy" [alt]="articulo.getDescripCion()">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
           [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
           [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>
    <div class="descriofer">
      <div class="descprod">

      </div>
      <div class="cantidadofer">
        <!--$ x Lt. 100-->

      </div>
      <div *ngIf='!ocultarPrecios'>
        <div class="precie">
          {{articulo.getPrecioAmostrar() | currency}}
        </div>
      </div>
      <div class="btnarena">
        <boton-sumador (quantyEvent)="sumaevent($event)" [contador]="articulo.getCantidad()">
        </boton-sumador>
      </div>

    </div>

  </div>


</div>

<div class="layout-mobile" *ngIf="mode==='precheckout'">
  <div class="remplazosview">
    <div class="image-container-watermark">
      <img *ngIf="articulo.getImgDownload()" class="myimg" [src]="articulo.getFotoImagen()" [heigth]="150" [width]="150"
        loading="lazy">
      <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
           [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
           [style.opacity]="genServ.getOpacidadMarcadeagua()">
      </div>
    </div>
    <div class="detalles">
      <div class="leyendaprecheck">
        {{articulo.getDescripCion()}}
      </div>
      <div class="presecheckout">
        {{articulo.getPresentacion()}}
      </div>

      <div class="remplazadorchekout">

      </div>
    </div>
    <div class="unidades">
      <div class="preciocheckoutmobile">
        {{ getPrecioCalculadoCarrito() | currency }}
      </div>
      <div class="blueboton">
        <span>{{articulo.getCantidad()}} un.</span>
        <span *ngIf="permiteBultosArticulo() || articulo.getCantidadBultos() > 0">
          / {{articulo.getCantidadBultos()}} b.
        </span>
      </div>
    </div>
  </div>
  <div class="sectorremplz">
    Reemplazo:
    <selector-generico [mode]="'inputSel'" [remplazos]="misremplasos" [seleRem]="articulo.getRemplazo()"
      (onSelect)="categoriaSelec($event)"></selector-generico>
  </div>

</div>